<template>
  <div class="sumsub_verification_dialog">
    <el-dialog class="sumsub_status_dialog" :visible="visible" @close="close">
      <Result>
        <template #statusIcon>
          <StatusIcon :customIcon="statusIcon" />
        </template>
        <template #title>
          <div>
            {{ $t(statusTitle) }}
          </div>
        </template>
        <div>
          {{ $t(statusDesc) }}
        </div>
        <template #customButton>
          <el-button v-if="isVerifyRequired" class="sumsub_dialog_button" @click="verifyNow">{{
            $t('sumsub.verifyNow')
          }}</el-button>
          <div v-else style="margin-bottom: 24px" />
        </template>
      </Result>
    </el-dialog>
    <el-dialog
      class="sumsub_websdk_dialog"
      :visible="isShowSumsubDialog"
      :show-close="false"
      @close="isShowSumsubDialog = false"
    >
      <!-- display: flex to avoid extra space between iframe and container -->
      <div id="sumsub-websdk-container" style="display: flex"></div>
    </el-dialog>
  </div>
</template>

<script>
import snsWebSdk from '@sumsub/websdk';
import { apiGetSumsubAccessToken } from '@/resource';
import Result from '@/components/Result.vue';
import StatusIcon from '@/components//StatusIcon.vue';
import { I18N_PLATFORM_MAP } from '@/constants/language';

export const sumsubStatusEnum = { init: 'INIT', pending: 'PENDING', success: 'SUCCESS', fail: 'FAIL' };

export default {
  name: 'SumsubVerificationDialog',
  components: { Result, StatusIcon },
  props: {
    campaignId: { type: Number, required: true },
    visible: { type: Boolean, default: false },
    sumsubStatus: { type: String, default: sumsubStatusEnum.init }
  },
  data() {
    return { accessToken: '', isShowSumsubDialog: false };
  },
  computed: {
    isVerifyRequired() {
      return this.sumsubStatus === sumsubStatusEnum.init || this.sumsubStatus === sumsubStatusEnum.fail;
    },
    statusIcon() {
      switch (this.sumsubStatus) {
        case sumsubStatusEnum.pending:
          return require('@/assets/images/sumsub/under_review_status_icon.png');
        case sumsubStatusEnum.fail:
          return require('@/assets/images/new/icon_status_error.png');
        default:
          return require('@/assets/images/sumsub/verification_status_icon.png');
      }
    },
    statusTitle() {
      switch (this.sumsubStatus) {
        case sumsubStatusEnum.pending:
          return 'sumsub.underReviewTitle';
        case sumsubStatusEnum.fail:
          return 'sumsub.failTitle';
        default:
          return 'sumsub.verificationRequiredTitle';
      }
    },
    statusDesc() {
      switch (this.sumsubStatus) {
        case sumsubStatusEnum.pending:
          return 'sumsub.underReviewDesc';
        case sumsubStatusEnum.fail:
          return 'sumsub.failDesc';
        default:
          return 'sumsub.verificationRequiredDesc';
      }
    },
    sumsubLang() {
      switch (this.lang) {
        case 'zh_CN':
          return 'zh';
        case 'zh_TW':
          return 'zh-tw';
        default:
          return I18N_PLATFORM_MAP[this.lang] || 'en';
      }
    }
  },
  methods: {
    close() {
      this.$emit('close');
      this.$emit('update:visible', false);
    },
    async launchWebSdk() {
      this.isShowSumsubDialog = true;
      await setTimeout(() => {}, 500);
      const snsWebSdkInstance = snsWebSdk
        .init(this.accessToken, () => this.getAccessToken())
        .withConf({
          lang: this.sumsubLang,
          theme: 'dark' | 'light'
        })
        .withOptions({ addViewportTag: false, adaptIframeHeight: true })
        .on('idCheck.onApplicantStatusChanged', resp => {
          if (resp.reviewStatus === 'completed') {
            if (resp.reviewResult.reviewAnswer === 'GREEN') {
              this.$router.go(0);
            }
            if (resp.reviewResult.reviewAnswer === 'RED' && resp.reviewResult.reviewRejectType !== 'RETRY') {
              this.$emit('update:sumsubStatus', sumsubStatusEnum.fail);
              this.close();
            }
          } else {
            this.$emit('update:sumsubStatus', sumsubStatusEnum.pending);
          }
        })
        .build();
      snsWebSdkInstance.launch('#sumsub-websdk-container');
    },
    async getAccessToken() {
      try {
        const res = await apiGetSumsubAccessToken(this.campaignId);
        if (res.data.code === 0) {
          return res.data.data;
        } else {
          return '';
        }
      } catch (error) {
        console.log(error);
        return '';
      }
    },
    async verifyNow() {
      this.accessToken = await this.getAccessToken();
      if (this.accessToken?.length > 0) {
        this.launchWebSdk();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sumsub_verification_dialog {
  .sumsub_status_dialog {
    /deep/ .el-dialog {
      max-width: 500px;
    }
  }
  .sumsub_websdk_dialog {
    /deep/ .el-dialog {
      overflow: hidden;
      padding: 0;
      max-width: 500px;
      .el-dialog__header {
        margin: 0;
      }
    }
  }

  .sumsub_dialog_button {
    width: 100%;
  }
}
</style>
